import React from "react";
import { connect } from "react-redux";
import { Input } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import toastMessage from "../../utils/toastMessage";
import { fetchQualysResult } from "../../utils/queries/qualysResult";
import { Modal } from "../Modal";
import NewTest from "./BloodGrouping/NewTest";
import api from "../../utils/api";

class AutomaticTest extends React.Component {
  state = {
    sampleId: "",
    donationNumber: "",
    error: {},
    sampleData: {},
    isFetchingSampleData: false,
// eslint-disable-next-line no-dupe-keys
  };

  onChangeText(field, e) {
    let { error } = this.state;
    delete error[field];

    const value = e && e?.target ? e?.target?.value : e;

    this.setState({
      [field]: value,
      error,
    });
  }

  validateForm() {
    let { error, sampleId, donationNumber, sampleData } = this.state;

    if (!sampleId || sampleId === "") {
      error.sampleId = language[this.props.defaultLanguage].sample_id_required;
    }

    if (
      (!donationNumber || donationNumber === "") &&
      Object.keys(sampleData).length > 0
    ) {
      error.donationNumber =
        language[this.props.defaultLanguage].donation_number_required;
    }

    this.setState({ error });
  }

  onSearch = async () => {
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      try {
        const { data } = await fetchQualysResult(this.props.defaultLanguage, {
          page: 1,
          limit: 1,
          sampleId: this.state.sampleId,
        });
        const sampleData = Array.isArray(data) ? data[0] : data;
        this.setState({
          sampleData,
          isSubmitting: false,
        });

        if (sampleData?._id) {
          this.setState({
            modalOpen: "SAMPLE_DATA",
          });
        } else {
          this.setState({
            sampleData: {},
            modalOpen: "",
          });
          toastMessage(
            "error",
            language[this.props.defaultLanguage].sample_not_found,
          );
        }
      } catch (error) {
        this.setState({ isSubmitting: false, sampleData: {} });
        toastMessage("error", error);
      }
    }
  };

  onSubmit = async () => {
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      try {
        const options = {
          method: "POST",
          url: `${process.env.REACT_APP_BBMS_BASE_API}/qualys/results/confirm`,
          data: {
            sampleId: this.state.sampleId,
            donationNumber: this.state.donationNumber,
          },
        };

        const data = await api(options);
        this.setState({
          isSubmitting: false,
        });

        if (data?.data?.testId) {
          this.setState({
            testId: data?.data?.testId,
            modalOpen: "TEST_FORM",
            previousTestResults: data?.data?.previousTestResults,
          });
        }
      } catch (error) {
        toastMessage("error", error);
        this.setState({ isSubmitting: false, testId: null });
      }
    }
  };

  handleCloseModal() {
    this.setState({
      modalOpen: "",
    });
  }

  onReset = () => {
    this.setState({
      sampleId: "",
      donationNumber: "",
      error: {},
      sampleData: {},
      isFetchingSampleData: false,
    });
// eslint-disable-next-line no-dupe-keys
  };

  render() {
    return (
      <div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <Input
                label={language[this.props.defaultLanguage].sample_id}
                placeholder={
                  language[this.props.defaultLanguage].sample_id_placeholder
                }
                value={this.state.sampleId}
                onChange={(e) => this.onChangeText("sampleId", e)}
                error={this.state.error.sampleId}
                required
              />
            </div>
          </div>

          {this.state.sampleData?.sampleId && (
            <div style={{ marginTop: "0.5rem" }}>
              <div className="card-heading">
                <p className="text-primary">
                  {language[this.props.defaultLanguage].qualys_results}
                </p>
              </div>
              <div className="list-item-group card-body">
                <div className="list-item-card">
                  <div className="list-item-card-label">
                    {language[this.props.defaultLanguage].sample_id}
                  </div>
                  <div className="list-item-card-value">
                    {this.state.sampleData?.sampleId}
                  </div>
                </div>

                <div className="list-item-card">
                  <div className="list-item-card-label">
                    {language[this.props.defaultLanguage].instrument_run_id}
                  </div>
                  <div className="list-item-card-value">
                    {this.state.sampleData?.instrumentRunId}
                  </div>
                </div>
                <div className="list-item-card">
                  <div className="list-item-card-label">
                    {language[this.props.defaultLanguage].abo_group}
                  </div>
                  <div className="list-item-card-value">
                    {this.state.sampleData?.aboGroup}
                  </div>
                </div>
                <div className="list-item-card">
                  <div className="list-item-card-label">
                    {language[this.props.defaultLanguage].rh}
                  </div>
                  <div className="list-item-card-value">
                    {this.state.sampleData?.rh}
                  </div>
                </div>
                <div className="list-item-card">
                  <div className="list-item-card-label">
                    {language[this.props.defaultLanguage].phenotype}
                  </div>
                  <div className="list-item-card-value">
                    {this.state.sampleData?.phenotype}
                  </div>
                </div>
                <div className="list-item-card">
                  <div className="list-item-card-label">
                    {language[this.props.defaultLanguage].operator}
                  </div>
                  <div className="list-item-card-value">
                    {this.state.sampleData?.operator}
                  </div>
                </div>
                <div className="list-item-card">
                  <div className="list-item-card-label">
                    {language[this.props.defaultLanguage].date}
                  </div>
                  <div className="list-item-card-value">
                    {this.state.sampleData?.observedAt}
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.state.sampleData?.sampleId && (
            <Input
              label={language[this.props.defaultLanguage].donation_number}
              value={this.state.donationNumber}
              onChange={(e) => this.onChangeText("donationNumber", e)}
              error={this.state.error.donationNumber}
              required
              placeholder={
                language[this.props.defaultLanguage].donation_number_placeholder
              }
              type="number"
            />
          )}
        </div>

        <div
          className="d-flex gap-3"
          style={{ paddingLeft: "1rem", paddingBottom: "1rem" }}
        >
          {this.state.sampleData?._id ? (
            <>
              <Button
                text={language[this.props.defaultLanguage].reset}
                onPress={this.onReset.bind(this)}
                className="btn-default"
              />
              <Button
                text={language[this.props.defaultLanguage].confirm}
                onPress={this.onSubmit.bind(this)}
                isSubmitting={this.state.isSubmitting}
              />
            </>
          ) : (
            <Button
              text={language[this.props.defaultLanguage].search}
              onPress={this.onSearch.bind(this)}
              isSubmitting={this.state.isFetchingSampleData}
            />
          )}
        </div>
        <Modal
          show={this.state.modalOpen === "TEST_FORM"}
          handleClose={this.handleCloseModal.bind(this, "TEST_FORM")}
          size="lg"
        >
          <NewTest
            sampleData={this.state.sampleData}
            handleCloseModal={this.handleCloseModal.bind(this)}
            testId={this.state.testId}
            previousTestResults={this.state.previousTestResults}
            onResetForm={this.onReset.bind(this)}
            canConfirm={true}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(AutomaticTest);
